import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M106.5 74.29c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#0597A3"
      d="M82.89 21.82a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M15.98 63.29a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      d="m16.99 83.98 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM108.57 30.45H103v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5H100v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path
      fill="#0597A3"
      d="M83.68 68.42c0 1.97-.93 3.82-2.5 5.01C77.25 76.41 68.94 81.5 58 81.5s-19.17-5.1-23.15-8.08a6.29 6.29 0 0 1-2.53-5.03V52.44h51.36z"
    />
    <path
      fill="#00D8D8"
      d="M57.05 65.88 23.16 49.44c-1.63-.79-1.63-3.11 0-3.9L57.05 29.1c.6-.29 1.3-.29 1.89 0l33.89 16.44c1.63.79 1.63 3.11 0 3.9L58.94 65.88c-.6.29-1.3.29-1.89 0"
    />
    <path
      fill="#001A43"
      d="M77.44 89.3c-1.2 0-2.18-.98-2.18-2.18V58.01l-18.18-8.55a2.18 2.18 0 0 1-1.05-2.9 2.18 2.18 0 0 1 2.9-1.05l19.44 9.14c.76.36 1.25 1.13 1.25 1.97v30.49c0 1.2-.98 2.18-2.18 2.18z"
    />
  </svg>
);
const SvgEnrichedIconLearningAcademyInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconLearningAcademyInverted);
export default Memo;
